export const accountDataRouteFlags = (pathname: string) => {
  const loadPortfolio = pathname.startsWith("/portfolio");
  const loadPortfolioOrders = pathname.startsWith("/portfolio/orders");
  const loadStake = pathname.startsWith("/stake");
  const loadTrade = pathname.startsWith("/trade") || loadPortfolioOrders;
  const loadLending = pathname.startsWith("/lend");
  const loadStrategies =
    pathname.startsWith("/strategies") || loadLending;

  return {
    loadAutoClaimer: loadStake || loadTrade,
    loadBalancesPool: loadPortfolio || loadStrategies,
    loadBorrow: pathname.startsWith("/borrow"),
    loadIndex: pathname.startsWith("/index"),
    // This query flag also includes DebtsAccountFragment, which the lending
    // overview reads. Strategy data alone does not create its Relay fragment ref.
    loadLiquidate: pathname.startsWith("/liquidate") || loadLending,
    loadMerge: pathname.startsWith("/merge") || loadPortfolio,
    loadPortfolio,
    loadStake,
    loadStrategies,
    loadTrade,
  };
};
